import React, { useEffect, useState } from 'react';
import { locales } from '../../../../translations/locales';
import { _$ } from '../../../../controllers/dom';
import BtnStatus from '../status/BtnStatus';

const UpdateIncident = (props) => {
    const { updateIncident, locale, theme, data, sigData, incident } = props;
    const [services, setServices] = useState([]);
    const [responses, setResponses] = useState([]);
    const [waitingAddLevel, setWaitingAddLevel] = useState(false);
    const [loaded, setLoaded] = useState(false);

    const addService = () => {
        const incidentService = _$('incidentService').value;
        setServices([...services, incidentService]);
    };

    const removeService = (service) => {
        setServices(services.filter((s) => s !== service));
    };

    const addResponse = () => {
        if (waitingAddLevel) {
            const response = responses.find((r) => r._id === waitingAddLevel);
            response.function += _$('incidentResponse').value;
            setResponses([...responses]);
            setWaitingAddLevel(false);
        } else {
            const newResponses = {
                _id: Math.random().toString(36).substr(2, 9),
                function: _$('incidentResponse').value,
            };
            setResponses([...responses, newResponses]);
        }
    };

    const removeResponse = (responseId) => {
        setResponses(responses.filter((r) => r._id !== responseId));
    };

    const addLevel = (responseId) => {
        const response = responses.find((r) => r._id === responseId);
        if (response.function.slice(-2) === '||') return;
        response.function += `||`;
        setResponses([...responses]);
        setWaitingAddLevel(responseId);
    };

    const addMultipleLevel = (responseId) => {
        const response = responses.find((r) => r._id === responseId);
        if (response.function.slice(-2) === '+') return;
        response.function += `+`;
        setResponses([...responses]);
        setWaitingAddLevel(responseId);
    };

    const deleteLevel = (responseId) => {
        const response = responses.find((r) => r._id === responseId);
        if (response.function.slice(-2) === '||') {
            response.function = response.function.slice(0, -2);
        } else {
            const level = response.function.split('||');
            level.pop();
            response.function = level.join('||');
        }
        setResponses([...responses]);
    };

    const createIncident = () => {
        const updatedIncident = {
            id: incident.id,
            category: _$('incidentCategory').value,
            reason: _$('incidentReason').value,
            place: _$('incidentPlace').value,
            responses,
            services,
        };
        updateIncident(updatedIncident);
    };

    useEffect(() => {
        if (incident && !loaded) {
            _$('incidentCategory').value = incident.category;
            _$('incidentReason').value = incident.reason;
            _$('incidentPlace').value = incident.place;
            setResponses(incident.responses);
            setServices(incident.services);
            setLoaded(true);
        }
    }, [services, responses]);

    return (
        <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
            <div className="card container p-0 gameInformations mt-5">
                <h5 className="card-header bg-primary">
                    {locales[locale].config.addIncidentType}
                    <button
                        type="button"
                        className="btn btn-danger btn-sm ml-1 float-right pt-0 pb-0"
                        onClick={() => updateIncident(null)}
                    >
                        x
                    </button>
                </h5>
                <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <div className='row'>
                        <div className='col-6'>
                            <div className="form-group">
                                <label htmlFor="incidentCategory">{locales[locale].config.incidentCategory}</label>
                                <select className="form-control" id="incidentCategory">
                                    {
                                        sigData.categories.map((category) => {
                                            return (
                                                <option key={category} value={category}>
                                                    {locales[locale].sga[category]}
                                                </option>
                                            );
                                        })
                                    }
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="incidentReason">{locales[locale].config.incidentReason}</label>
                                <input type="text" className="form-control" id="incidentReason" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="incidentPlace">{locales[locale].config.incidentPlace}</label>
                                <select className="form-control" id="incidentPlace">
                                    <option value='NO_PLACE'>{locales[locale].sig['NO_PLACE']}</option>
                                    {
                                        Object.entries(sigData.places).map(([key, value]) => {
                                            return (
                                                <optgroup key={key} label={locales[locale].sig[key]}>
                                                    {
                                                        value.types.map((place) => {
                                                            return (
                                                                <option key={place} value={place}>
                                                                    {locales[locale].sig[place] || place}
                                                                </option>
                                                            );
                                                        })
                                                    }
                                                </optgroup>
                                            );
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <div className="form-group">
                                <label htmlFor="incidentResponse">{locales[locale].config.incidentResponse}</label>
                                {responses.map((r) => (
                                    <div key={r._id} className="ml-2">
                                        {
                                            r.function.split('||').map((f, i) => (
                                                i === 0 ? (
                                                    <div key={i} className={`ml-2`}>
                                                        <BtnStatus
                                                            listStatus={data.status}
                                                            code={9}
                                                            text={data.functions.find((func) => func.id === f).name}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-info btn-sm ml-2 pt-0 pb-0"
                                                            onClick={() => addLevel(r._id)}
                                                        >
                                                            {locales[locale].config.or}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm ml-2 pt-0 pb-0"
                                                            onClick={() => removeResponse(r._id)}
                                                        >
                                                            x
                                                        </button>
                                                    </div>
                                                ) : data.functions.find((func) => func.id === f || f.split('+')[0]) ? (
                                                    <div key={i} className={`ml-5`}>
                                                        {
                                                            f.split('+').map((f2, i2) => (
                                                                <span key={i2}>
                                                                    <BtnStatus
                                                                        listStatus={data.status}
                                                                        code={9}
                                                                        text={data.functions.find((func) => func.id === f2)?.name || '?'}
                                                                    />
                                                                    {i2 < f.split('+').length - 1 && <span key={i2}>+</span>}
                                                                </span>
                                                            ))
                                                        }
                                                        {
                                                            f.split('+').length === 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-info btn-sm ml-2 pt-0 pb-0"
                                                                    onClick={() => addMultipleLevel(r._id)}
                                                                >
                                                                    +
                                                                </button>
                                                            )
                                                        }
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm ml-2 pt-0 pb-0"
                                                            onClick={() => deleteLevel(r._id)}
                                                        >
                                                            x
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div key={i} className="">
                                                        <h6 key={i} className="badge badge-danger mr-1 ml-5">
                                                            --
                                                        </h6>
                                                    </div>
                                                )
                                            ))
                                        }

                                    </div>
                                ))}
                                {
                                    responses.length === 0 &&
                                    <li key='no' className="ml-5">
                                        {locales[locale].config.noResponse}
                                    </li>
                                }
                                <select className="form-control" id="incidentResponse">
                                    {
                                        data.functions.map((func) => {
                                            return (
                                                <option key={func.id} value={func.id}>
                                                    {func.name}
                                                </option>
                                            );
                                        })
                                    }
                                </select>
                                <div className='text-right'>
                                    <button type="button" className="btn btn-primary btn-sm mt-1" onClick={addResponse}>
                                        {locales[locale].config.add}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className="form-group">
                                <label htmlFor="incidentService">{locales[locale].config.servicesToContact}</label>
                                <ul className="list-group">
                                    {services.map((service) => (
                                        <li key={service} className="ml-5">
                                            {data.services.find((s) => s._id === service).name}
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm ml-1 float-right pt-0 pb-0"
                                                onClick={() => removeService(service)}
                                            >
                                                x
                                            </button>
                                        </li>
                                    ))}
                                    {
                                        services.length === 0 &&
                                        <li className="ml-5">
                                            {locales[locale].config.noService}
                                        </li>
                                    }
                                </ul>
                                <select className="form-control" id="incidentService">
                                    {data.services.map((service) => (
                                        <option key={service._id} value={service._id}>{service.name}</option>
                                    ))}
                                    {
                                        data.services.length === 0 &&
                                        <option>{locales[locale].config.noServiceAvailable}</option>
                                    }
                                </select>
                                <div className='text-right'>
                                    <button type="button" className="btn btn-primary btn-sm mt-1" onClick={addService}>
                                        {locales[locale].config.addService}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='text-right'>
                        <button type="button" className="btn btn-primary" onClick={createIncident}>
                            {locales[locale].config.update}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateIncident;
